import { useState } from 'react'
import { useAtomValue } from 'jotai'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'

import { useDeleteYearlyFeeDiscount } from '@/hooks/api/use-yearly-fee-discount'
import { selectedMunicipalityIdAtom } from '@/state'

function RemoveDialog({
    yearlyFeeDiscountId,
    handleClose,
    successCallback,
}: {
    yearlyFeeDiscountId: number,
    handleClose: () => void,
    successCallback?: () => void,
}) {

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)

    const municipalityId = useAtomValue(selectedMunicipalityIdAtom)

    const mutation = useDeleteYearlyFeeDiscount(
        yearlyFeeDiscountId,
        municipalityId,
        {
            setRequestInProgress,
            onSuccessCallback(data) {
                if(data) {
                    setSuccess(true)
                }
            }
        },
    )

    const handleClickDelete = () => {
        setRequestInProgress(true)
        mutation.mutate()
    }

    return (
        <Box sx={{
            minWidth: 200,
            minHeight: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {success ?
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                }}>
                    <DeleteRoundedIcon sx={{
                        color: 'terciary.main',
                        fontSize: '4rem',
                    }}/>
                    <Typography variant="body1" component="div">
                        Sleva úspěšně smazána.
                    </Typography>
                    <Button
                        variant="contained"
                        color="terciary"
                        size="small"
                        onClick={() => {
                            setSuccess(false)
                            if (successCallback) {
                                successCallback()
                            } else {
                                handleClose()
                            }
                        }}
                    >
                        {successCallback ? 'Zpět na seznam' : 'Zavřít'}
                    </Button>
                </Box>
                :
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Typography variant="h5" component="div" mb={2}>
                        Potvrďte prosím smazání slevy ID: {yearlyFeeDiscountId}
                    </Typography>
                    <Typography variant="body2" component="div" mb={2}>
                        Tato akce slevu vymaže z tohoto seznamu a dalších navázaných seznamů.
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexGrow: 1,
                    }}>
                        <Button
                            variant="text"
                            color="terciary"
                            onClick={() => handleClose()}
                        >
                            Zrušit
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <DeleteRoundedIcon />}
                            onClick={() => handleClickDelete()}
                            disabled={requestInProgress}
                        >
                            Smazat
                        </Button>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default RemoveDialog
